// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider-title[data-v-27645cac] {\n  line-height: 20px;\n  font-size: 12px;\n}\n.slider-bar-box[data-v-27645cac] {\n  text-align: left;\n}\n.slider-bar[data-v-27645cac] {\n  line-height: 20px;\n  display: inline-block;\n  width: 100%;\n  height: 6px;\n  border-radius: 5px;\n  background-color: #f5c319;\n}\n", ""]);
// Exports
module.exports = exports;
